import React from 'react';
import {
  StyleSheet,
  TouchableOpacity,
  Text,
  StyleProp,
  ViewStyle,
  TextStyle,
  Platform,
  useWindowDimensions,
} from 'react-native';
import { applyTransparency } from '../../constants/colors';
import { BackIcon } from '../../resources/svgComponents/BackIcon';
import { isMobile } from '@mightybyte/rnw.utils.device-info';
import LinearGradient from 'react-native-linear-gradient';

interface IBackButtonV2Props {
  onPress: () => void;
  text?: string;
  style?: StyleProp<ViewStyle>;
  textStyle?: StyleProp<TextStyle>;
  containerStyle?: StyleProp<ViewStyle>;
}
const BackButtonV2 = (props: IBackButtonV2Props) => {
  const { width } = useWindowDimensions();
  const isMobileWeb = Platform.OS === 'web' && width <= 768;

  return (
    <LinearGradient
      colors={['#FF9900', '#F1BF77']}
      start={{ x: 0, y: 0 }}
      end={{ x: 1, y: 1 }}
      style={styles.gradientBorder}
    >
      <TouchableOpacity style={[styles.container, props.containerStyle]} onPress={props.onPress}>
        <BackIcon />
        {props.text && !isMobile && !isMobileWeb && (
          <Text maxFontSizeMultiplier={1} style={[styles.text, props.textStyle]}>
            {props.text}
          </Text>
        )}
      </TouchableOpacity>
    </LinearGradient>
  );
};

export { BackButtonV2 };

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#FFFFFF',
    height: 49,
    borderRadius: 11,
    paddingHorizontal: 10,
  },
  text: {
    fontFamily: 'Secular One',
    fontSize: 22,
    marginLeft: 10,
    marginTop: 4,
    color: '#453B3B',
    fontWeight: '400',
  },
  gradientBorder: {
    borderRadius: 16,
    paddingTop: 0,
    paddingBottom: 2.5,
    paddingRight: 2.5,
    height: 55,
  },
});
